const cscPrepareConclusion = {
    namespaced: true,
    state: {
        isVisible: false,

        resolve: null,
        reject: null,

        address: null,
        phone: null,
        conclusion: null,
        recommendations: null,
        reallyBefore: null,
        cheif: null,
        specialists: []
    },
    mutations: {
        SET_IS_VISIBLE(state, payload) {
            state.isVisible = payload;
        },
        SET_RESOLVE(state, payload) {
            state.resolve = payload;
        },
        SET_REJECT(state, payload) {
            state.reject = payload;
        },
        SET_ADDRESS(state, payload) {
            state.address = payload;
        },
        SET_PHONE(state, payload) {
            state.phone = payload;
        },
        SET_CONCLUSION(state, payload){
            state.conclusion = payload;
        },
        SET_RECOMMENDATIONS(state, payload){
            state.recommendations = payload;
        },
        SET_REALLY_BEFORE(state, payload){
            state.reallyBefore = payload;
        },
        SET_CHEIF(state, payload){
            state.cheif = payload;
        },
        SET_SPECIALISTS(state, payload){
            state.specialists = payload
        }
    },
    actions: {
        async open({ commit }) {
            commit('SET_IS_VISIBLE', true);
            
            //Initialize
            commit('SET_ADDRESS', null);
            commit('SET_PHONE', null);
            commit('SET_CONCLUSION', null);
            commit('SET_RECOMMENDATIONS', null);
            commit('SET_REALLY_BEFORE', null);
            commit('SET_CHEIF', null);
            commit('SET_SPECIALISTS', []);


            return new Promise((resolve, reject) => {
                commit('SET_RESOLVE', resolve);
                commit('SET_REJECT', reject);
            });
        },

        async ok({ commit, state, rootGetters }) {
            commit('SET_IS_VISIBLE', false);

            let result =  {
                DocumentId: rootGetters['global/actionsource/getDataSource'].Data.Object.Document.id,
                PMPK_Address: state.address,
                PMPK_Phone: state.phone,
                PMPK_Conclusion: state.conclusion,
                PMPK_Recommendation: state.recommendations,
                PMPK_ReallyBefor: this._vm.$moment(state.reallyBefore).format("DD.MM.YYYY"),
                PMPK_Cheif: state.cheif?.name ?? "",
                PMPK_Specialists: state.specialists?.map(s => s.name).join(', ')
            };
            
            state.resolve(result);
        },
        async cancel({ commit, state }) {
            commit('SET_IS_VISIBLE', false);
            state.reject({ message: "Cancelled" });
        },
    },
    getters: {
        isVisible: (s) => s.isVisible,
        
        isValid: (s) => (s.address && s.phone && s.conclusion && s.recommendations && s.reallyBefore && s.cheif && s.specialists),
        getAddress: (s) => s.address,
        getPhone: (s) => s.phone, 
        getConclusion: (s) => s.conclusion,
        getRecommendations: (s) => s.recommendations,
        getReallyBefore: (s) => s.reallyBefore,
        getCheif: (s) => s.cheif,
        getSpecialists: (s) => s.specialists       
    }
}

export default cscPrepareConclusion;